import useRetrieveData from 'global/hooks/useRetrieveData';
import { useSelector } from 'react-redux';
import { get } from 'global/lib/lodash';

export const useBuilders = () => {
  const meRealm = useSelector((state) => get(state, 'auth.user.realm'));

  const builders = useRetrieveData(
    { url: '/realms' },
    {
      build: ['realms'],
      useCache: { reload: 20 },
      params: {
        directRelate: 1,
        filter: {
          tier: 'builder',
        },
      },
      transformData: (data) => {
        // The user's realm may not always be present in the builders list. Add it if not already included.
        if (!meRealm) return data || [];
        const alreadyIncluded = (data || []).some((builder) => builder.id === meRealm.id);
        return alreadyIncluded ? data : [...(data || []), meRealm];
      },
    }
  );

  // Check if data exists (because if not the transform also doesn't run to add meRealm)
  return builders.data?.length ? builders.data : [meRealm];
};

export default useBuilders;
